import React from "react";
import HomePageParagraph from "../utils/HomePageParagraph";
import HomePageParticipateLink from "../utils/HomePageParticipateLink";

// eslint-disable-next-line react/prop-types
function SurveyFinishedView({ translate, survey, surveyIsActive, onRevisionPhase, isSurveyFinished, surveyUrl }) {
  return (
    <React.Fragment>
      <p className="sia-text-10">{translate("benchmarking.landing-page.logged-in.lead")}</p>
      <HomePageParagraph
        translate={translate}
        survey={survey}
        surveyIsActive={surveyIsActive}
        onRevisionPhase={onRevisionPhase}
        isSurveyFinished={isSurveyFinished}
      />
      <HomePageParticipateLink
        translate={translate}
        surveyIsActive={surveyIsActive}
        onRevisionPhase={onRevisionPhase}
        isSurveyFinished={isSurveyFinished}
        surveyUrl={surveyUrl}
      />
      <p className="sia-text-10">{translate("benchmarking.landing-page.logged-in.paragraph-2")}</p>
      <p className="sia-text-10">{translate("benchmarking.landing-page.logged-in.paragraph-3")}</p>
    </React.Fragment>
  );
}

export default SurveyFinishedView;
